/* Scroll reveal (HIS-118 second review). The store's previous theme faded these parts in as they scrolled into
   view: on mobile once a section's top is 148px above the bottom of the window, on desktop once the group's topmost
   part is 90px above it; then its parts appear one after another, 0.15s apart, each over 0.65s from transparent and
   a 1px blur (measured on its render with scripts/probes/parity_reveal_trigger.mjs and parity_reveal_steps.js). The
   styles are in hisola-chrome.css. Without IntersectionObserver, or with reduced motion asked for, nothing is hidden. */
(function () {
  if (window.HisolaReveal) return;
  window.HisolaReveal = true;
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  // Each group: the section, then its steps in order; "each" gives every match its own step.
  var GROUPS = [
    { section: '.image-with-text', steps: [{ items: '.image-with-text__grid' }] },
    { section: '.hisola-results', steps: [{ items: '.hisola-results__title, .hisola-results__text' },
      { items: '.hisola-results__body' }] },
    { section: '.hisola-testimonials', steps: [{ items: '.hisola-testimonials__title, .hisola-testimonials__text' },
      { items: '.hisola-testimonials__card', each: true }] },
    { section: '.footer', steps: [{ items: '.footer-block--menu' }, { items: '.footer-block--newsletter' },
      { items: '.footer__content-bottom' }] }
  ];
  var STEP = 0.15;

  function mark() {
    var targets = [];
    GROUPS.forEach(function (group) {
      Array.prototype.forEach.call(document.querySelectorAll(group.section), function (root) {
        if (root.dataset.hisolaReveal) return;
        root.dataset.hisolaReveal = 'pending';
        var step = 0;
        var parts = [];
        group.steps.forEach(function (s) {
          var found = Array.prototype.slice.call(root.querySelectorAll(s.items));
          if (!found.length) return;
          found.forEach(function (el, i) {
            el.style.setProperty('--hisola-reveal-delay', ((step + (s.each ? i : 0) + 1) * STEP).toFixed(2) + 's');
            el.classList.add('hisola-reveal');
            parts.push(el);
          });
          step += s.each ? found.length : 1;
        });
        var section = root.closest('.shopify-section') || root;
        section.hisolaRevealParts = (section.hisolaRevealParts || []).concat(parts);
        targets.push(section);
      });
    });
    return targets;
  }

  function start() {
    var targets = mark();
    if (!targets.length) return;
    // Mobile: the section's top 148px inside the window. Desktop, where sections have top padding: the group's
    // topmost part 90px inside (measured per group on the previous theme's render, in 10-20px scroll steps).
    var mobile = window.innerWidth < 750;
    var margin = mobile ? -148 : -90;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        (entry.target.hisolaRevealParts || []).forEach(function (el) { el.classList.add('is-revealed'); });
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px ' + margin + 'px 0px' });
    targets.forEach(function (section) {
      var watch = section;
      if (!mobile) {
        (section.hisolaRevealParts || []).forEach(function (el) {
          if (watch === section || el.getBoundingClientRect().top < watch.getBoundingClientRect().top) watch = el;
        });
        if (watch !== section) watch.hisolaRevealParts = section.hisolaRevealParts;
      }
      observer.observe(watch);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
